import { BanwordsTab } from './SettingsPage';
import styles from './SettingsPage.module.scss';

export function BanwordsPage() {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <h1 className={styles.title}>Mots interdits</h1>
          <p className={styles.subtitle}>Gérez la liste des mots et expressions bannis du chat</p>
        </div>
      </header>

      <div className={styles.content}>
        <BanwordsTab />
      </div>
    </div>
  );
}
